(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const sliderElement = document.getElementById('slider-testimonials');
  if (!sliderElement) return;

  const track = sliderElement.querySelector('.vanilla-slider__track');
  const slides = Array.from(track.children);
  const nextButton = sliderElement.querySelector('.vanilla-slider__btn--next');
  const prevButton = sliderElement.querySelector('.vanilla-slider__btn--prev');
  const dotsNav = sliderElement.querySelector('.vanilla-slider__dots');

  if (slides.length <= 1) return;

  const slideCount = slides.length;
  let currentIndex = 0;
  let autoplayInterval = null;
  let isTransitioning = false; // Флаг для предотвращения двойной прокрутки

  // Определяем, сколько слайдов клонировать в зависимости от размера экрана
  const getSlidesToClone = () => window.innerWidth >= 1024 ? 3 : (window.innerWidth >= 750 ? 2 : 1);
  let slidesToClone = getSlidesToClone();

  const firstClones = slides.slice(0, slidesToClone).map(slide => slide.cloneNode(true));
  const lastClones = slides.slice(-slidesToClone).map(slide => slide.cloneNode(true));
  
  firstClones.forEach(clone => track.appendChild(clone));
  lastClones.reverse().forEach(clone => track.insertBefore(clone, slides[0]));
  
  const allSlides = Array.from(track.children);
  const getSlideWidth = () => allSlides[0].getBoundingClientRect().width;
  
  const setInitialPosition = () => {
    track.style.transition = 'none';
    currentIndex = slidesToClone;
    track.style.transform = `translateX(-${currentIndex * getSlideWidth()}px)`;
  }

  for (let i = 0; i < slideCount; i++) {
    const dot = document.createElement('button');
    dot.classList.add('vanilla-slider__dot');
    dot.addEventListener('click', () => {
      moveToSlide(i + slidesToClone);
      resetAutoplay();
    });
    dotsNav.appendChild(dot);
  }
  const dots = Array.from(dotsNav.children);

  const updateDots = () => {
    const realIndex = (currentIndex - slidesToClone + slideCount) % slideCount;
    dots.forEach((dot, index) => {
      dot.classList.toggle('vanilla-slider__dot--active', index === realIndex);
    });
  };

  const moveToSlide = (index) => {
    if (isTransitioning) return; // Блокируем новые анимации, пока текущая не завершена
    isTransitioning = true;
    
    track.style.transition = 'transform 0.5s ease-in-out';
    currentIndex = index;
    track.style.transform = `translateX(-${currentIndex * getSlideWidth()}px)`;
    updateDots();
  };

  const handleTransitionEnd = () => {
    isTransitioning = false; // Разрешаем новые анимации
    if (currentIndex <= slidesToClone - 1) {
      track.style.transition = 'none';
      currentIndex += slideCount;
      track.style.transform = `translateX(-${currentIndex * getSlideWidth()}px)`;
    }
    if (currentIndex >= slideCount + slidesToClone) {
      track.style.transition = 'none';
      currentIndex -= slideCount;
      track.style.transform = `translateX(-${currentIndex * getSlideWidth()}px)`;
    }
  };

  const startAutoplay = () => {
    clearInterval(autoplayInterval);
    autoplayInterval = setInterval(() => {
      moveToSlide(currentIndex + 1);
    }, 5000);
  };

  const resetAutoplay = () => {
    clearInterval(autoplayInterval);
    startAutoplay();
  };
  
  nextButton.addEventListener('click', () => {
    moveToSlide(currentIndex + 1);
    resetAutoplay();
  });
  prevButton.addEventListener('click', () => {
    moveToSlide(currentIndex - 1);
    resetAutoplay();
  });

  track.addEventListener('transitionend', handleTransitionEnd);
  sliderElement.addEventListener('mouseenter', () => clearInterval(autoplayInterval));
  sliderElement.addEventListener('mouseleave', () => startAutoplay());

  setInitialPosition();
  updateDots();
  startAutoplay();
  
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      track.style.transition = 'none';
      // Пересчитываем ширину и позицию, т.к. количество видимых слайдов могло измениться
      track.style.transform = `translateX(-${currentIndex * getSlideWidth()}px)`;
    }, 200);
  });
});

  } catch(e) { console.error(e); }
})();
})();
